export default "__VITE_ASSET__BH$tGooJ__"